module.exports = __webpack_public_path__ + "static/img/logo2.d26d3c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo2.png
// module id = +r+x
// module chunks = 0